import { Participant, Track } from "livekit-client";
import { useEffect, useState } from "react";

function handleTrackEvents<T extends Track>(
  trackType: Track.Source,
  setTrack: React.Dispatch<React.SetStateAction<T | undefined>>,
  participant?: Participant
) {
  const updateTrack = () => {
    const trackPublication = participant?.getTrackPublication(trackType);
    setTrack(trackPublication?.track as T);
  };

  if (participant) {
    updateTrack();
    participant.on("trackSubscribed", updateTrack);
    participant.on("trackUnsubscribed", updateTrack);
    participant.on("localTrackPublished", updateTrack);
    participant.on("localTrackUnpublished", updateTrack);
  }

  return () => {
    if (participant) {
      participant.off("trackSubscribed", updateTrack);
      participant.off("trackUnsubscribed", updateTrack);
      participant.off("localTrackPublished", updateTrack);
      participant.off("localTrackUnpublished", updateTrack);
    }
  };
}

export function useTrack<T extends Track>(
  trackType: Track.Source,
  participant?: Participant
) {
  const [track, setTrack] = useState<T>();

  useEffect(() => {
    return handleTrackEvents(trackType, setTrack, participant);
  }, [participant, trackType]);

  return track;
}
